<template>
  <div id="app">
    <TopNav/>
    <router-view></router-view>
    <Footer/>
  </div>
</template>

<script>
import TopNav from './components/TopNav'
import Footer from './components/Footer'

export default {
  name: 'App',
  components:{TopNav,Footer},

}
</script>
<style lang="less">
#app{
  position: relative;
  height: 100%;
  //background: url("./assets/img/flower.jpg");
}
.sy{
  font-family: sy;
}
.wrap{
  max-width: 1920px;
  margin: 0 auto;
}
.jc500{
  font-family: jc500;
}
@font-face {
  font-family: jc500;
  src:url("./assets/fonts/jc500.ttf");
}
@font-face {
  font-family: sy;
  src:url("./assets/fonts/sy.ttf");
}


</style>




// WEBPACK FOOTER //
// src/App.vue